export class Screen {
  constructor(readOnly, screenId, screenTitle, hasDeleteAuthority) {
    this.readOnly = readOnly;
    this.screenId = screenId;
    this.screenTitle = screenTitle;
    this.hasDeleteAuthority = hasDeleteAuthority;
  }

  static factory(readOnly, screenId, screenTitle, hasDeleteAuthority) {
    return new Screen(readOnly, screenId, screenTitle, hasDeleteAuthority);
  }
}
